import React, { useState, useEffect, useRef } from 'react';
import './ModeSwitcherDropdown.css';

function ModeSwitcherDropdown({ activeMode, switchMode }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Mapping of backend keys to display names
  const modeNames = {
    'LONG_CONTEXT': 'Long Context Mode',
    'RAG': 'RAG Mode'
  };

  const handleDropdownClick = () => {
    setIsOpen(!isOpen);
  };

  const handleModeClick = (mode) => {
    switchMode(mode); // Pass the key to the switchMode function
    setIsOpen(false); // Close dropdown after selection
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false); // Close dropdown if clicked outside
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // If activeMode is not in the mapping, show a default placeholder
  const displayModeName = modeNames[activeMode] || "Select Mode";

  return (
    <div className="mode-switcher-container" ref={dropdownRef}>
      <button className="mode-switcher-button" onClick={handleDropdownClick}>
        {displayModeName} {/* Display the user-friendly name or placeholder */}
        <span className="dropdown-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" className="icon-md text-token-text-tertiary">
            <path fill="currentColor" fillRule="evenodd" d="M5.293 9.293a1 1 0 0 1 1.414 0L12 14.586l5.293-5.293a1 1 0 1 1 1.414 1.414l-6 6a1 1 0 0 1-1.414 0l-6-6a1 1 0 0 1 0-1.414" clipRule="evenodd"></path>
          </svg>
        </span>
      </button>
      {isOpen && (
        <div className="dropdown-content">
          <div className={`dropdown-item ${activeMode === 'RAG' ? 'active' : ''}`} onClick={() => handleModeClick('RAG')}>
            <span className="icon">📚</span>
            <div className="mode-info">
              <div className="mode-name">RAG Mode</div>
              <div className="mode-desc">Best for retrieval tasks</div>
            </div>
          </div>
          <div className={`dropdown-item ${activeMode === 'LONG_CONTEXT' ? 'active' : ''}`} onClick={() => handleModeClick('LONG_CONTEXT')}>
            <span className="icon">📜</span>
            <div className="mode-info">
              <div className="mode-name">Long Context Mode</div>
              <div className="mode-desc">Best for detailed tasks</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ModeSwitcherDropdown;

